import { useState, useCallback, useEffect } from 'react';
import { Modal, message } from '@/components';
import { LegacyButtonType } from 'antd/lib/button/button';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { chat as chatModel } from '@/models';

let chatDisableModal: any = null;
export default function useChatInMeeting() {
  const { chat } = useLocalStore(() => {
    return {
      chat: chatModel,
    };
  });
  const { formatMessage } = useIntl();

  const toggleChatBtnDisableStatus = async (body) => {
    if (window.isMobile) return;
    if (body.state === 0) {
      if (!chat.chatVisible) {
        message.info({
          content: formatMessage({
            id: 'THE_MODERATOR_HAS_CLOSED_THE_CHAT_IN_THE_MEETING',
          }),
          noIcon: true,
        });
        chat.setIsAbleUse(false);
      } else {
        // @ts-ignore
        // @ts-ignore
        // @ts-ignore
        chatDisableModal = Modal.info({
          bodyStyle: {
            fontSize: '18px',
            lineHeight: '25px',
            color: '#FFFFFF',
          },
          width: 450,
          title: formatMessage({ id: 'THE_HOST_HAS_TURNED_OFF_THE_MEETING_CHAT_FUNCTION' }),
          closable: false,
          okText: formatMessage({ id: 'CONFIRM' }),
          onOk: async () => {
            message.info({
              content: formatMessage({
                id: 'THE_MODERATOR_HAS_CLOSED_THE_CHAT_IN_THE_MEETING',
              }),
              noIcon: true,
            });
            chat.setIsAbleUse(false);
          },
          keyboard: false,
          okType: 'chat-disable-btn' as LegacyButtonType,
        });
      }
    } else {
      chat.setIsAbleUse(true);
      message.info({
        content: formatMessage({ id: 'THE_HOST_HAS_STARTED_CHATTING_IN_THE_MEETING' }),
        noIcon: true,
      });
      if (chatDisableModal) chatDisableModal.destroy();
    }
  };

  return toggleChatBtnDisableStatus;
}
